var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2 img",class:{
    active: _vm.value == _vm.bot.value,
    primary: _vm.value == _vm.bot.value,
    islock: _vm.bot.isLock
  }},[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
  var on = ref.on;
return [_c('v-avatar',_vm._g({},on),[_c('img',{staticClass:"responsive-img circle",staticStyle:{"min-width":"100%"},attrs:{"alt":"","src":'https://graph.facebook.com/' +
            _vm.bot.value +
            '/picture?width=100&height=100&SameSite=None'}})])]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bot.name))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da941a9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/livechat/livechat-avatar.vue
// module id = null
// module chunks = 